/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useContext, useEffect, useState } from 'react'
import CardHeader from '../../../../../components/CardHeader'
import UpdateButton from '../../../../../components/UpdateButton'
import Toast from '../../../../../components/Toast'
import TextArea from '../../../../../components/TextArea'
import Input from '../../../../../components/InputBox'
import CustomeDatePicker from '../../../../../components/DatePicker'
import DropDownComponent from '../../../../StudentMaster/Directory/Components/AddStudentComponents/DropDownComponent'
import { dataService } from '../../../../../services/data.services'
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId'
import SearchItemField from './SearchItemField'
import { useNavigate, useParams } from 'react-router-dom'
import GlobalContext from '../../../../../components/Context/GloablContext'
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt'
import AnimatedModel from '../../../../../components/Animation/AnimatedModel'
import { useSelector } from 'react-redux'
import WarningMessage from '../../../../../components/WarningMessage'
import CustomOverLay from '../../../../../components/CustomOverlay'
import { ShimmerTitle } from 'react-shimmer-effects'

export default function AddPurchaseOrder({type}) {
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const {setToastmessage, reloadFY, setReloadFY, isSideNavBar} = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const nonEmptyField = ["po_date", "delivery_date", "vendor_name"]
    const navigate = useNavigate();
    
    const moment = require('moment');
    const currentDate = moment();
    let formattedDate = '';
    const fy = JSON.parse(localStorage.getItem('FY_details'));
    const fy_start_date = new Date(fy.start_date);
    const fy_end_date = new Date(fy.end_date);
    if ((currentDate >= fy_start_date && currentDate <= fy_end_date)) {
        formattedDate = currentDate.format('MMM DD,YYYY');
    }
    const initialState = {
        po_date : formattedDate,
        delivery_date: "",
        financial_year: `${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`,
        description : "",
        vendor_name : ""
    }
    const [fyDate, setFyDate] =  useState({
        start_date : JSON.parse(localStorage.getItem('FY_details')).start_date,
        end_date : JSON.parse(localStorage.getItem('FY_details')).end_date,
        financial_year : `${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`
    })
    const [params, setParams] = useState('')
    const newFields = {item_name: '', item_code: '', uom :"" , quantity: "",cost_price : "", total_price : ""}
    const [loadingPage, setLoadingPage] = useState(type === "Add" ? false : true)
    const [newStateFields, setNewStateFields] = useState([newFields]);
    const [state, setState] = useState(initialState)
    const [dateError, setdateError] = useState("");
    const [warningMessage, setWarningMessage] = useState('')
    let {id} = useParams();
    const [showDropdown, setshowDropdown] = useState({
        blood_group: false,
        gender: false,
        economic_status: false,
        religion: false,
        caste_category: false,
        academic_year: false,
        class: false,
        section: false,
    });
    const [submitSelected, setsubmitSelected] = useState(false);
    const [descriptionCount, setDescriptionCount] = useState(null)
    const [dateErrorSelected, setDateErrorSelected] = useState("");
    const [ledgerNames, setLedgerNames] = useState([])
    const [selectedErrorState, setSelectedErrorState] = useState(null)
    const {userType} = useSelector((state)=>state.auth);

    /**
     * The function `handleValidations` checks for empty or zero values in specific fields and returns
     * true if any validation fails.
     * @returns The function `handleValidations` is returning a boolean value indicating whether there
     * are validation errors or not. If `count` is not equal to 0, it means there are validation errors
     * and the function will return `true`. Otherwise, it will return `false`.
     */
    const handleValidations = () => {
        let count = 0;
        nonEmptyField.map((item) => {
            if (String(state[item]) === "") {
                count = count + 1;
            }
        });
        const fields = ["item_name", "quantity", "cost_price", "item_code"];
        newStateFields.forEach((item) => {
            fields.forEach((field) => {
                if (Number(item['quantity']) === 0 && item['quantity'] !== '') {
                    count ++
                } else if (parseFloat(Number(item['cost_price'])).toFixed(2) === "0.00" && item['cost_price'] !== '') {
                    count ++
                }
                if (String(item[field]).trim() === "") {
                    count++;
                }
            });
        });
        return count !== 0;
    };
    
    /**
     * The handleSubmit function in this JavaScript React code handles form submission for adding or
     * updating purchase orders, including validations and API calls.
     * @returns The `handleSubmit` function is being returned.
     */
    const handleSubmit = async() => {
        if(!(userType==='institution-user' || userType==='institution-admin') && type === "Add") {
            const branch_id = await GetBranchId()
            const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing&sort=status%2Basc`, true);
            if(res.data.data.ongoing !== JSON.parse(localStorage.getItem('FY_details')).name) {
                setToastErrorMessage(`You are not authorized to add PO for the ${JSON.parse(localStorage.getItem('FY_details')).name}`)
                return
            }
        }
        if(openConfirmation) {
            setActivateButtonLoading(true)
        } else {
            setLoading(true)
        }
        if(handleValidations()){
            newStateFields.forEach((item) => {
                if (Number(item['quantity']) === 0 && item['quantity'] !== '') {
                    setsubmitSelected(true)
                    setSelectedErrorState(null)
                    if(parseFloat(Number(item['cost_price'])).toFixed(2) === "0.00" && item['cost_price'] !== ''){
                        setToastErrorMessage('Quantity and Cost/Item must be greater than Zero')
                    } else {
                        setToastErrorMessage('Quantity must be greater than Zero')
                    }
                    setLoading(false)
                    setOpenConfirmation(false)
                    setActivateButtonLoading(false)
                    return ;
                } else if (parseFloat(Number(item['cost_price'])).toFixed(2) === "0.00" && item['cost_price'] !== '' ) {
                    setsubmitSelected(true)
                    setSelectedErrorState(null)
                    if(Number(item['quantity']) === 0){
                        setToastErrorMessage('Quantity and Cost/Item must be greater than Zero')
                    } else {
                        setToastErrorMessage('Cost/Item must be greater than Zero')
                    }
                    setLoading(false)
                    setOpenConfirmation(false)
                    setActivateButtonLoading(false)
                    return ;
                } else {
                    setsubmitSelected(true)
                    setSelectedErrorState(null)
                    setToastErrorMessage("Please fill in all the mandatory fields")
                    setLoading(false)
                    setOpenConfirmation(false)
                    setActivateButtonLoading(false)
                    return
                }
            })
        } else {
            try {
                let body = {
                    items: newStateFields,
                    description: state.description,
                    financial_year : type === "Add" ? JSON.parse(localStorage.getItem('FY_details')).name : fyDate.financial_year,
                    delivery_date : moment(state?.delivery_date).format("YYYY-MM-DD"),
                    po_date : moment(state?.po_date).format("YYYY-MM-DD"),
                    fy_start_date : fyDate.start_date,
                    fy_end_date : fyDate.end_date,
                    branch_id : await GetBranchId(),
                    // po_number : state.po_number.trim(),
                    vendor_name : state.vendor_name,
                    vendor_id : state.vendor_id,
                    po_amount :  newStateFields.reduce((acc, item) => acc + (parseFloat(item.total_price) || 0), 0).toFixed(2)
                }
                let response = null
                if(type === "Add") {
                    response = await dataService.PostAPI(body, 'purchase-order');
                } else {
                    response = await dataService.PatchAPI(body, `purchase-order/${id}`);
                }
                setOpenConfirmation(false)
                setToastmessage(type === "Add" ? response?.data.data?.message : "Purchase order updated successfully");
                navigate(type === "Add" ? `/inventory-master/purchase-order` : `/inventory-master/purchase-order?${params}`)
            } catch (error) {
                setOpenConfirmation(false)
                setActivateButtonLoading(false)
                setLoading(false);
                setToastErrorMessage(error?.response?.data?.message);
            }
        }
    }


    const clearIfValueIsZero = (index, name) => (e) => {
        if (Number(e.target.value) === 0) {
            console.log(name);
            handleFieldChange(index, name, '');
        }
    };

    const setZeroIfEmpty = (index, name) => (e) => {
        let value = e.target.value;
        if (value.trim() === '') {
            value = '0.00';
        } else {
            value = parseFloat(value).toFixed(2);
        }
        console.log(name);
        handleFieldChange(index, name, value);
    };

    /**
     * The handleInput function in JavaScript React updates state based on user input, with a specific
     * check for the "description" field to limit the word count to 100 words.
     */
    const handleInput = (e) => {
        let {id,value}=e.target

        if(id === "description") {
            const words = value?.trim().split(/\s+/);
            const currentWordCount = words?.length;
            setDescriptionCount(currentWordCount)
            if (currentWordCount <= 100) {
                setState((prv)=>({
                    ...prv,
                    [id]:value
                }))
            } else {
                setToastErrorMessage("Description cannot exceed 100 words")
            }
        } else {
            setState((prv)=>({
                ...prv,
                [id]:value
            }))
        }
    }
    
    /**
     * The function `handleSelectedDate` validates if a selected date falls within a specified range
     * and updates the state accordingly.
     */
    const handleSelectedDate = (id, date, dateString) => {
        setDateErrorSelected("");
        id === "po_date" ? setState((prv) => ({
            ...prv,
            "delivery_date": ''
        })) :  ''
        const selectedDate = moment.utc(dateString); // Parse as UTC
        const startDate = id === "po_date" ? moment.utc(fyDate.start_date) : moment.utc(state.po_date); // Parse as UTC
        const endDate = moment.utc(fyDate.end_date); // Parse as UTC

        if (id === "po_date" ? selectedDate.isSameOrAfter(startDate) && selectedDate.isSameOrBefore(endDate) : selectedDate.isSameOrAfter(startDate)) {
            setState((prev) => ({
                ...prev,
                [id]: dateString,
            }));
        } else {
            setState((prev) => ({
                ...prev,
                [id]: "",
            }));
            setDateErrorSelected(id);
            setToastErrorMessage(
                id === "po_date"
                    ? `PO Date must be within the ${type === "Add" ? `${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})` : fyDate.financial_year} `
                    : `Delivery Date must be after PO Date ${moment(state?.po_date).format("MMM DD, YYYY")}`
            );
        }
    };

    /**
     * The function `handleDropDownValue` updates the state with a key and value, and then calls
     * another function `handleDropdown`.
     */
    const handleDropDownValue = (key, value) => {
        setState((prv) => ({
            ...prv,
            [key]: value.ledger_name,
            "vendor_id": value._id
        }));
        handleDropdown(key);
    };
 
    /**
     * The handleDropdown function toggles the visibility of a dropdown element based on the key
     * provided.
     */
    const handleDropdown = (key) => {
        setToastErrorMessage('')
        setsubmitSelected(false);
        setSelectedErrorState(null)
        setshowDropdown((prv) => ({
            ...prv,
            [key]: !showDropdown[key],
        }));
    };

    /**
     * This function retrieves vendor names for current liabilities from an API based on the branch ID.
     */
    const getVenderName = async() => {
        const branch_id = await GetBranchId();
        const res = await dataService.GetAPI(`groups-and-ledgers?branch_id=${branch_id}&type=ledger&search=Liabilities > Current Liabilities > Sundry Creditors&status=active&filter=true&list_ledger=true&role=purchase-order`);
        setLedgerNames(res.data.data.data)
    }

    /**
     * The function `handleRemoveClassField` removes a specific element from an array and updates the
     * state with the modified array.
     */
    const handleRemoveClassField = (indexToRemove) => {
        // setEmptyField(false);
        setsubmitSelected(false)
        setSelectedErrorState(null)
        setToastErrorMessage('')
        const updatedClassFields = newStateFields.filter((_, index) => index !== indexToRemove);
        setNewStateFields(updatedClassFields);
    };

    /**
     * The function `handleAddClassField` updates state fields and displays a warning message if the
     * number of fields reaches 19.
     */
    const handleAddClassField = () => {
        setsubmitSelected(false)
        setSelectedErrorState(null)
        // setEmptyField(false);
        setToastErrorMessage('')
        const updatedClassFields = [
            ...newStateFields,
            newFields,
        ];
        setNewStateFields(updatedClassFields);

        if (newStateFields?.length === 19)  {
            setToastErrorMessage('')
            setWarningMessage("Items")
        }
    };

    /**
     * The function `handleSearchFiled` checks if an item code already exists in a list and updates the
     * fields accordingly.
     */
    
    const handleSearchFiled = (index, items) => {
        const itemCode = items.item_code;
        setSelectedErrorState(null);
        setToastErrorMessage("")
        const updatedClassFields = [...newStateFields];
        updatedClassFields[index]["item_code"] = "";
        updatedClassFields[index]["uom"] = "";
        updatedClassFields[index]["item_name"] = "";
        // Check if the item_code already exists in newStateFields
        const itemExists = updatedClassFields.some(field => field.item_code === itemCode);
    
        if (itemExists) {
            // You can throw an error or handle it as you see fit. For example:
            // setError('Item with this code already exists in the list.');
            // return; // Stop further processing
    
            // For this example, I'm logging an error message
            setSelectedErrorState(index)
            setToastErrorMessage(`Duplicate Entry: Item '${items.item_name}' is already added`); 
        } else {
            // Item does not exist, so you can proceed to update the fields
            const updatedClassFields = [...newStateFields];
            updatedClassFields[index]["item_code"] = items.item_code;
            updatedClassFields[index]["uom"] = items.uom;
            updatedClassFields[index]["item_name"] = items.item_name;
            updatedClassFields[index]["quantity"] = 1;
            updatedClassFields[index]["cost_price"] = '0.00';
            updatedClassFields[index]["total_price"] = '0.00';
        }
        setNewStateFields(updatedClassFields);

    };

    /**
     * The function `handleFieldChange` in JavaScript React sanitizes and validates input values for
     * quantity and cost price fields, calculates total price, and updates the state accordingly.
     */
    const handleFieldChange = (index, name, value) => {
        // Remove any non-numeric and non-dot characters
        const inputValue = name === "quantity" ? value.replace(/[^\d]/g, '') :  value.replace(/[^\d.]/g, '');
        const updatedClassFields = [...newStateFields];
        if(name === "quantity") {
            if(inputValue === "") {
                updatedClassFields[index]["total_price"] = "";
            }
            updatedClassFields[index][name] = inputValue;
        } else {
            // Limit to a maximum length of 5 characters (including decimal and decimals)
            if (inputValue?.length <= 13 ) {
                // Allow only up to 2 decimal places
                const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
                if (regex.test(inputValue)) {
                    if(inputValue === "") {
                        updatedClassFields[index]["total_price"] = "";
                    }
                    updatedClassFields[index][name] = inputValue;
                }
            }
        }
        if(updatedClassFields[index].quantity === "0" || updatedClassFields[index].cost_price === "0" || updatedClassFields[index].quantity === 0 || updatedClassFields[index].cost_price === 0){
            updatedClassFields[index]["total_price"] = '0.00'
        }else if(updatedClassFields[index].quantity !== "" && updatedClassFields[index].cost_price !== "") {
            const total_price =  Number(updatedClassFields[index].quantity) * Number(updatedClassFields[index].cost_price).toFixed(2)
            updatedClassFields[index]["total_price"] = total_price.toFixed(2);
        }
        setNewStateFields(updatedClassFields); 
    }

    /**
     * The function getViewData fetches data from an API endpoint and updates state variables with the
     * retrieved data.
     */
    const getViewData = async() => {
        const res= await dataService.GetAPI(`purchase-order/${id}`);
        setNewStateFields(res?.data?.data?.items)
        setState({
            po_date: res?.data?.data.po_date,
            // po_number: res?.data?.data?.po_number,
            financial_year: res?.data.data?.financial_year,
            description : res?.data?.data?.description,
            vendor_name : res?.data?.data?.vendor_name,
            delivery_date : res?.data?.data?.delivery_date
        })
        setFyDate({
            start_date : res?.data?.data?.fy_start_date,
            end_date: res?.data?.data?.fy_end_date,
            financial_year: res?.data.data?.financial_year,
        })
        setLoadingPage(false)
    }

    /* The above code is a React useEffect hook that is triggered when the `reloadFY` state variable
    changes. */
    useEffect(() => {
        getVenderName()
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        setParams(searchParams.toString())
        if(reloadFY) {
            setLoadingPage(true)
            if(type === "Add") {
                setState(initialState)
                setNewStateFields([newFields])
                setFyDate({
                    start_date : JSON.parse(localStorage.getItem('FY_details')).start_date,
                    end_date : JSON.parse(localStorage.getItem('FY_details')).end_date,
                    financial_year : `${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`
                })
            } else {
                getViewData()
            }
            setReloadFY(false)
            setTimeout(() => {
                setLoadingPage(false)
            }, 1000);
        } else {
            if(type === "Edit") {
                getViewData()
            }
        }
    },[reloadFY])

    /**
     * The function `handelOpenFY` sets the `activateButtonLoading` state to false and opens a
     * confirmation dialog.
     */
    const handelOpenFY = async() => {
        setActivateButtonLoading(false)
        setOpenConfirmation(true)
    }

    const disabledFutureDate = (current) => {
        // Disable dates that are after the current date
        return current && current > moment().endOf('day');
    };

    return (
        <CardHeader noPadding>
            <div class="mainDataCntnrTop shadow-s13" style={{position: "sticky", position: "-webkit-sticky"}}>
                <h5 class="pageHeader addclass">{type === "Add" ? `Create` : `Edit`}  Purchase Order</h5>
                <div class="flex items-center">
                    <UpdateButton
                        ButtonName={"Cancel"}
                        loading={false}
                        handleOnCLick={() => navigate(type === "Add" ? `/inventory-master/purchase-order` : `/inventory-master/purchase-order?${params}`)}
                        classKey="cancl-btn"
                    />
                    <UpdateButton
                        loading={loading}
                        ButtonName={type !== "Add" ? "Update" : "Add"}
                        handleOnCLick={() => {(type === "Add" && JSON.parse(localStorage.getItem('FY_details')).status === "open" )? handelOpenFY() : handleSubmit()}}
                        classKey={"actn-btn onboardInstitution"}
                    />
                </div>
                {toastErrorMessage!=='' &&<Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
                {warningMessage !== "" && <WarningMessage 
                    warningMessage={warningMessage}
                    setWarningMessage={setWarningMessage}
                />}
            </div>
            {loadingPage&&<CustomOverLay Active text="Loading ..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}
            {!loadingPage&&
            <div className='mainDataCntnrPageDiv scrollBlue_thick'>
                <div className='2xl:w-[60%] w-[70%] mx-auto'>
                    <div className='border  p-4 rounded'>
                        <div className='flex -mx-10'>
                            <div className='w-[50%] px-10'>
                                <div className='flex'>
                                    <div className='relative flex items-center mb-4 w-full'>
                                        <label for="date_of_birth" class="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">PO Date</label>
                                        <div class="relative w-full">
                                            <CustomeDatePicker 
                                                setToastErrorMessage={setToastErrorMessage}
                                                setsubmitSelected={setsubmitSelected}
                                                id='po_date'
                                                format="MMM DD, YYYY"
                                                isMandatoryField={true}
                                                showErrorBorder={(submitSelected && state.po_date === "" || dateErrorSelected === "po_date")}
                                                state={state}
                                                placeholder="Select PO Date"
                                                imageClass={true}
                                                setdateError={setdateError}
                                                handleSelect={handleSelectedDate}
                                                disabledFutureDate={disabledFutureDate}
                                                // disabledDate={!JSON.parse(localStorage.getItem('FY_details')).start_date}
                                                // disabledFutureDate={!JSON.parse(localStorage.getItem('FY_details')).start_date}
                                                //onBlur={onBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='flex'>
                                    {/* PO Number is automatted and feild is not required */}
                                    {/* <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='uom'
                                            className='text-f7 font-normal text-[#031624] min-w-[120px] inline-flex'
                                        >
                                            PO #
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="po_number"
                                            maxLength={30}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter PO #"}
                                            placeholder={"Enter PO #"}
                                            isMandatoryField={true}
                                        />
                                    </div> */}
                                </div>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='item_code'
                                            className='text-f7 font-normal text-[#031624] min-w-[120px] inline-flex'
                                        >
                                            Financial Year
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="financial_year"
                                            maxLength={30}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter Item Code"}
                                            placeholder="Enter Item Code"
                                            disable={true}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='w-[50%] px-10'>
                                <div className='flex'>
                                    <div className='relative flex items-center mb-4 w-full'>
                                        <label for="vendor_name" class="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">Vendor Name</label>
                                        <DropDownComponent 
                                            options={ledgerNames}
                                            isMandatoryField ={true}
                                            showErrorBorder = {submitSelected && state.vendor_name === ""}
                                            dropdownkey={"vendor_name"}
                                            studentDetails={state}
                                            submitSelected={submitSelected}
                                            handleDropDownValue={handleDropDownValue}
                                            showDropdown={showDropdown}
                                            handleDropdown={handleDropdown}
                                            placeholder={"Select Vendor Name"}
                                            selectedvalue={state.vendor_name}
                                            stateStatus={false}
                                            obj={"ledger_name"}
                                        />
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='relative flex items-center mb-4 w-full'>
                                        <label for="date_of_birth" class="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">Delivery Date</label>
                                        <div class="relative w-full">
                                            <CustomeDatePicker 
                                                setToastErrorMessage={setToastErrorMessage}
                                                setsubmitSelected={setsubmitSelected}
                                                id='delivery_date'
                                                showErrorBorder={(submitSelected && state.delivery_date === "") || (dateErrorSelected === "delivery_date")}
                                                isMandatoryField={true}
                                                format="MMM DD, YYYY"
                                                state={state}
                                                placeholder="Select Delivery Date"
                                                imageClass={true}
                                                setdateError={setdateError}
                                                handleSelect={handleSelectedDate}
                                                disabledDate={state.po_date === ""}
                                                //onBlur={onBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class=" flex">
                                    <label for="Description" class="text-f7 mt-3 font-medium mb-1.5 min-w-[120px]">Description</label>
                                    <div className='h-[56px] w-full'>
                                        <TextArea
                                            type="text"
                                            state={state}
                                            id="description"
                                            handleInput={handleInput}
                                            wordsLength={descriptionCount > 100}
                                            setsubmitSelected={setsubmitSelected}
                                            maxLength={100}
                                            text="Address is mandatory"
                                            placeholder ="Enter Description"
                                        />
                                    </div>
                                    {/* <textarea id="description" class="w-full border  rounded-lg py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] shadow-s7 h-[128px] resize-none" placeholder="Enter Description"></textarea> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mb-4 2xl:w-[87%] w-[94%] mx-auto border border-[#E6E8EA]' style={{'margin-top':'45px'}}>
                    <div className='flex items-center p-2 pb-[0px] formHeaderbg'>
                        <div className={`flex items-center pb-[7px] border-b border-[#E6E8EA]  w-[100%]`}>
                            <div className={`pr-2 pl-1 w-[24%]`}>
                                <p className='w-full text-f7 font-semibold text-[#031624] mr-4'>Item Name</p>
                            </div>
                            <div className='px-2 w-[14%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624]'>Item Code</p>
                            </div>
                            <div className='px-2 w-[14%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624]'>UoM</p>
                            </div>
                            <div className='px-2 w-[12%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624] '>Quantity</p>
                            </div>                            
                            <div className='px-2 w-[14%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624] text-right'>Cost / Item</p>
                            </div>
                            <div className='px-2 w-[14%] pr-1'>
                                <p className='w-full text-f7 font-semibold text-[#031624] text-right pr-1'>Total Cost</p>
                            </div>
                            <div className={`w-[7%] `}>
                            </div>
                        </div>
                    </div>
                    {newStateFields.map((field, index) => (
                        <div className='flex items-center' key={index+"po"}>
                            <div className={`flex items-center mt-[10px] pb-[10px] border-b border-[#E6E8EA]  w-[100%] `}>
                                <SearchItemField 
                                    handleSearchFiled={handleSearchFiled}
                                    index={index}
                                    setNewStateFields={setNewStateFields}
                                    newStateFields={newStateFields}
                                    submitSelected={submitSelected}
                                    selectedErrorState={selectedErrorState}
                                    setSelectedErrorState={setSelectedErrorState}
                                    setToastErrorMessage={setToastErrorMessage}
                                    ShimmerTitle={ShimmerTitle}
                                    noItemMsg = {`No Item found`}
                                />
                                <div className='w-[14%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            type="text"
                                            // onBlur={onBlur}
                                            autoComplete='off'
                                            id={`item_code${index}`}
                                            maxLength={30}
                                            disabled
                                            className={` ${submitSelected && field.item_code === "" ? "redBorder" : ""}  inpt-fld w-full error_border`}
                                            placeholder={``}
                                            value={field.item_code}
                                            // onChange={(e) => {setSelectedInput(index); handleClassFieldChange(index, 'name', e.target.value)}}
                                        />
                                    </div> 
                                </div>
                                <div className='w-[14%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            type="text"
                                            // onBlur={onBlur}
                                            autoComplete='off'
                                            id={`uom${index}`}
                                            maxLength={30}
                                            disabled
                                            className={` ${submitSelected && field.uom === "" ? "redBorder" : ""} inpt-fld w-full error_border`}
                                            placeholder={``}
                                            value={field.uom}
                                            // onChange={(e) => {setSelectedInput(index); handleClassFieldChange(index, 'name', e.target.value)}}
                                        />  
                                    </div>   
                                </div>
                                <div className='w-[12%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            type="text"
                                            // onBlur={onBlur}
                                            autoComplete='off'
                                            id={`quantity${index}`}
                                            maxLength={13}
                                            className={`${submitSelected && (field.quantity === "" || Number(field.quantity) === 0 ) ? "redBorder" : ""} inpt-fld w-full error_border`}
                                            placeholder={`1`}
                                            value={field.quantity}
                                            onChange={(e) => { handleFieldChange(index, 'quantity', e.target.value)}}
                                        />      
                                    </div>   
                                </div>
                                <div className='w-[14%] px-2'>
                                    <div class="relative w-full">
                                        <input
                                            type="text"
                                            // onBlur={onBlur}
                                            autoComplete='off'
                                            id={`cost_price${index}`}
                                            maxLength={13}
                                            className={`${submitSelected && (field.cost_price === "" || parseFloat(Number(field.cost_price)).toFixed(2) === '0.00') ? "redBorder" : ""}  crncy-inpt-fld w-full  error_border`}
                                            placeholder={`0.00`}
                                            value={field.cost_price}
                                            onChange={(e) => { handleFieldChange(index, 'cost_price', e.target.value)}}
                                            isAmountField = {true}
                                            onFocus={clearIfValueIsZero(index,'cost_price')}
                                            onBlur={setZeroIfEmpty(index,'cost_price')}
                                        />
                                        {/* <input type="text" id="openingBalance" class="border  rounded w-full error_border h-9 px-3.5 pl-8 text-base font-normal text-[#031624] placeholder:text-f7 placeholder:text-normal placeholder:text-[#818E98] outline-0 error_border" placeholder="Enter Amount"/> */}
                                        <p alt="icon" class="absolute top-[50%] -translate-y-[50%] left-[13px] text-f7 text-normal text-[#818E98]"> </p>
                                    </div>
                                </div>
                                <div className='w-[14%] px-2'>
                                    <div class="relative w-full">
                                        <input
                                            type="text"
                                            // onBlur={onBlur}
                                            autoComplete='off'
                                            id={`total_price${index}`}
                                            maxLength={13}
                                            className={` ${submitSelected && field.total_price === "" ? "redBorder" : ""} crncy-inpt-fld w-full error_border`}
                                            placeholder={`0.00`}
                                            value={field.total_price}
                                            onChange={(e) => { handleFieldChange(index, 'total_price', e.target.value)}}
                                            disabled
                                        />
                                        {/* <input type="text" id="openingBalance" class="border  rounded w-full error_border h-9 px-3.5 pl-8 text-base font-normal text-[#031624] placeholder:text-f7 placeholder:text-normal placeholder:text-[#818E98] outline-0 error_border" placeholder="Enter Amount"/> */}
                                        <p alt="icon" class="absolute top-[50%] -translate-y-[50%] left-[13px] text-f7 text-normal text-[#818E98]"> </p>
                                    </div>  
                                </div>
                                <div class={`w-[7%] flex items-center`}>
                                    {index === newStateFields?.length - 1 ? (
                                        <>
                                            {index !== 0 && <div className='group relative z-[10]'>
                                                <img
                                                    src="/images/delete-bg-red-icon.svg"
                                                    alt="icon"
                                                    className="ml-4 cursor-pointer delete-icon"
                                                    onClick={() => handleRemoveClassField(index)}
                                                />
                                                <span class="absolute top-7 left-[-3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>

                                            </div>}
                                            {index !== 19 &&<div className='group relative z-[10]'>

                                                <img
                                                    src="/images/add-icon-blue.svg"
                                                    id = "plus_iconn"
                                                    alt="icon"
                                                    className="ml-4 cursor-pointer add-icon"
                                                    onClick={() => handleAddClassField()} />
                                                <span class="absolute top-7 left-[7px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Add</span>
                                            </div>}
                                        </>
                                    ) : (
                                        <div className='group relative z-[10]'>
                                            <img
                                                src="/images/delete-bg-red-icon.svg"
                                                alt="icon"
                                                className="ml-4 cursor-pointer delete-icon"
                                                onClick={() => handleRemoveClassField(index)}
                                            />
                                            <span class="absolute top-7 left-[-3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>

                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>))}

                    <div className='flex items-center my-2' style={{'width':'91%'}}>
                        <p className='text-lg font-semibold text-black w-[100%] justify-end inline-flex mr-[5px]'>
                            <span className='w-[21%] justify-end inline-flex mr-[10px]'>PO Amount</span>
                            <span className='min-w-[14%] justify-end inline-flex'>{newStateFields.reduce((acc, item) => acc + (parseFloat(item.total_price) || 0), 0).toFixed(2)}</span>
                        </p>
                    </div>
                    
                </div>
            </div>}

            {openConfirmation && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleSubmit}
                        handleClose={() => setOpenConfirmation(false)}
                        crossMark
                        additionalMessage={`A PO is being created for '${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})', which appears to be a back-dated entry.`}
                        message = {`Do you want to continue?`}
                        buttonName = {`Continue`}
                        tittle={'Back Dated Entry'}
                        dialogueWidth={'500px'}
                        textPosition={'text-start'}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
        </CardHeader>
    )
}
